const OuterLink = ({ classname, link, children, onClick }) => {
  return (
    <a className={classname} href={link} rel="noreferrer noopener" target="_blank" onClick={onClick}>
      {children}
    </a>
  );
};

export default OuterLink;
